"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfBodyEncoding = exports.MAX_DECODED_PDF_BODY_BYTES = void 0;
exports.inspectPdfBody = inspectPdfBody;
const is_valid_pdf_1 = require("./is-valid-pdf");
const GZIP_MAGIC = [0x1f, 0x8b];
const GZIP_CONTENT_CODINGS = new Set(['gzip', 'x-gzip']);
const MIN_GZIP_MEMBER_BYTES = 18;
exports.MAX_DECODED_PDF_BODY_BYTES = 128 * 1024 * 1024;
var PdfBodyEncoding;
(function (PdfBodyEncoding) {
    PdfBodyEncoding["Identity"] = "identity";
    PdfBodyEncoding["Gzip"] = "gzip";
})(PdfBodyEncoding || (exports.PdfBodyEncoding = PdfBodyEncoding = {}));
async function inspectPdfBody(body, contentEncoding) {
    const gzipMagic = hasGzipMagic(body);
    if (gzipMagic || declaresGzip(contentEncoding)) {
        try {
            const inflated = await gunzip(body, exports.MAX_DECODED_PDF_BODY_BYTES);
            return { isPdf: (0, is_valid_pdf_1.bytesAreValidPdf)(inflated), bytes: inflated, encoding: PdfBodyEncoding.Gzip };
        }
        catch {
            if (gzipMagic) {
                return { isPdf: false, bytes: body, encoding: PdfBodyEncoding.Identity };
            }
        }
    }
    return { isPdf: (0, is_valid_pdf_1.bytesAreValidPdf)(body), bytes: body, encoding: PdfBodyEncoding.Identity };
}
function hasGzipMagic(bytes) {
    return bytes.length >= GZIP_MAGIC.length && bytes[0] === GZIP_MAGIC[0] && bytes[1] === GZIP_MAGIC[1];
}
function declaresGzip(contentEncoding) {
    return (contentEncoding ?? '').split(',').some((coding) => GZIP_CONTENT_CODINGS.has(coding.trim().toLowerCase()));
}
async function gunzip(bytes, maxOutputBytes) {
    if (bytes.length < MIN_GZIP_MEMBER_BYTES) {
        throw new RangeError('gzip body is shorter than one gzip member');
    }
    const declaredSize = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength).getUint32(bytes.byteLength - 4, true);
    if (declaredSize > maxOutputBytes) {
        throw new RangeError(`gzip body declares ${declaredSize} bytes, past ${maxOutputBytes}`);
    }
    const reader = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip')).getReader();
    const inflated = new Uint8Array(declaredSize);
    let size = 0;
    for (;;) {
        const { done, value } = await reader.read();
        if (done) {
            break;
        }
        if (size + value.byteLength > declaredSize) {
            await reader.cancel();
            throw new RangeError(`gzip body inflates past its declared ${declaredSize} bytes`);
        }
        inflated.set(value, size);
        size += value.byteLength;
    }
    return size === declaredSize ? inflated : inflated.subarray(0, size);
}
//# sourceMappingURL=pdf-body.js.map